/*
 * Barra de jornada de una persona: tramos de trabajo y de almuerzo sobre el eje 06:00-20:00 y el punto
 * de entrada con el color de la llegada. La línea dorada de la hora oficial (08:00) y la franja de
 * tolerancia (hasta 08:10) están en la misma posición en todas las barras: es la referencia visual del
 * tablero. Sábado y domingo (sin hora oficial) no dibujan la línea. Geometría: utils/timeline.js.
 * TimelineAxis dibuja las horas del eje (una vez, arriba de la lista).
 */
import React from "react";
import {arrivalStatus, toMinutes} from "../utils/rows";
import {
    OFFICIAL_MINUTES, TIMELINE_TICKS, TOLERANCE_MINUTES, currentMinutes, position, timelineLabel, timelineSegments,
} from "../utils/timeline";

const OFFICIAL_LEFT = position(OFFICIAL_MINUTES);
const TOLERANCE_WIDTH = position(OFFICIAL_MINUTES + TOLERANCE_MINUTES) - OFFICIAL_LEFT;

export const TimelineAxis = () => (
    <div className="mc-axis" aria-hidden="true">
        {TIMELINE_TICKS.map((hour) => (
            <span key={hour} className="mc-axis__tick" style={{left: `${position(hour * 60)}%`}}>
                {String(hour).padStart(2, '0')}
            </span>
        ))}
    </div>
);

const BarraJornada = ({row, today}) => {
    const segments = timelineSegments(row, row.fecha === today ? currentMinutes() : null);
    const entry = toMinutes(row.entrada);
    return (
        <div className="mc-timeline" role="img" aria-label={timelineLabel(row)}>
            {row.hora_oficial &&
                <span className="mc-timeline__tolerance" style={{left: `${OFFICIAL_LEFT}%`, width: `${TOLERANCE_WIDTH}%`}}/>}
            {segments.map((part) => (
                <span key={`${part.kind}-${part.left}`} className={`mc-timeline__segment mc-timeline__segment--${part.kind}`}
                      style={{left: `${part.left}%`, width: `${part.width}%`}}/>
            ))}
            {row.hora_oficial && <span className="mc-timeline__official" style={{left: `${OFFICIAL_LEFT}%`}}/>}
            {entry !== null &&
                <span className={`mc-timeline__entry mc-timeline__entry--${arrivalStatus(row).tone}`}
                      style={{left: `${position(entry)}%`}}/>}
        </div>
    );
};

export default BarraJornada;
